import { render, staticRenderFns } from "./auditStudent.vue?vue&type=template&id=2862a80e"
import script from "./auditStudent.vue?vue&type=script&lang=js"
export * from "./auditStudent.vue?vue&type=script&lang=js"
import style0 from "./auditStudent.vue?vue&type=style&index=0&id=2862a80e&prod&lang=less"
import style1 from "./auditStudent.vue?vue&type=style&index=1&id=2862a80e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports